import React, { useEffect, useRef, useState } from "react"
import LeftIcon from "../../images/LeftIcon"
import DatePicker from "react-datepicker";
import { webLoadingFalse, webLoadingTrue, webNavigate } from "../../services/navigate.service"
import { extractValues, validateEmail, validateNoSpecialChars, validateNoSpecialCharsOrSpaces, validateOnlyNumbers } from "../../validation/ValidationInput"
import ArrowClientsIcon from "../../images/ArrowClientsIcon"
import TableReport from "../../components/TableReport"
import { loadTerm } from "../../services/term.service"
import { getCountries } from "../../services/country.service";
import { createEmploy, getDetailsEmploy, updateDetailsEmploy } from "../../services/employ.service";
import ArrowRightIcon from "../../images/ArrowRightIcon";
import BackIcon from "../../images/BackIcon";
import { getDetailAsset } from "../../services/asset.service";
import PrintIcon from "../../images/PrintIcon";
interface InforTable {
    title: string;
    path: string;
    desc: string;
}

interface Country {
    id: string;
    code: string;
    name: string;
}
interface Category {
    id: string;
    code: string;
    name: string;
    children: CategoryChildren[]
}
interface CategoryChildren {
    id: string;
    code: string;
    name: string;
}
const CreateAssets = () => {
    const [formValues, setFormValues] = useState<any>();
    const [language, setLanguage] = useState<any>(null);
    const [no, setNo] = useState<any>();
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [clientsArray, setClientsArray] = useState<any>({
        count: 0,
        data: []
    });
    const [filter, setFilter] = useState<any>({
        page: 1,
        limit: 50,
        sort: "DESC"
    })
    const preLanguage = localStorage.getItem("language");
    const [countries, setCountries] = useState<Country[]>([]);
    const [listCategory, setListStatus] = useState<Category[]>([
        {
            "id": "1", "code": "Draft", "name": "Draft",
            children:
                [
                    {
                        "id": "1", "code": "Local purchase", "name": "Local purchase",
                    },
                    {
                        "id": "2", "code": "Expenses", "name": "Expenses",
                    },
                    {
                        "id": "3", "code": "Utilities", "name": "Utilities",
                    },
                ]
        },
        {
            "id": "2", "code": "Sent", "name": "Sent",
            children:
                [
                    {
                        "id": "1", "code": "Local purchase", "name": "Local purchase",
                    },
                    {
                        "id": "2", "code": "Expenses", "name": "Expenses",
                    },
                    {
                        "id": "3", "code": "Utilities", "name": "Utilities",
                    },
                ]
        },
        {
            "id": "3", "code": "Incomplete", "name": "Incomplete",
            children:
                [
                    {
                        "id": "1", "code": "Local purchase", "name": "Local purchase",
                    },
                    {
                        "id": "2", "code": "Expenses", "name": "Expenses",
                    },
                    {
                        "id": "3", "code": "Utilities", "name": "Utilities",
                    },
                ]
        },
    ])
    const companyId = localStorage.getItem("companyId");
    const categoryRef = useRef<HTMLDivElement>(null);
    const [categoryPurchase, setCategoryPurchase] = useState("");
    const [isCategoryDropdownOpen, setIsCategoryDropdownOpen] = useState(false);
    const [expandedCategoryId, setExpandedCategoryId] = useState<string | null>(null);

    const [gender, setGender] = useState<Country[]>([
        {
            id: "4",
            code: "123e4567-e89b-12d3-a456-426614174000",
            name: "Male"
        },
        {
            id: "5",
            code: "123e4567-e89b-12d3-a456-426614174000",
            name: "Female"
        },
    ]);
    const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);
    const [loading, setLoading] = useState<boolean>(false);
    const calculatedWidth = (windowWidth / 1290);
    const [termsArray, setTermsArray] = useState<any>({
        count: 0,
        data: []
    });
    const inforTable: InforTable = {
        title: "No Assets Found", path: "/assets/new", desc: "To display assets here, please first accept a purchase that includes asset items."
    }
    const path = window.location.pathname;
    const id: string = path.split('/').pop() || "";
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (categoryRef.current && !categoryRef.current.contains(event.target as Node)) {
                setIsCategoryDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.addEventListener('mousedown', handleClickOutside);
    }, []);
    useEffect(() => {
        if (window.languageContext) {
            setLanguage(window.languageContext.language);
        }
        if (window.noContext) {
            setNo(window.noContext.No)
        }
    }, [window, window.languageContext, window.noContext]);
    useEffect(() => {
        const filterParams: any = extractValues(location.search.split("&"));
        const data: any = {
            page: filterParams.page ? filterParams.page : filter.page,
            limit: filterParams.limit ? filterParams.limit : filter.limit,
            year: "",
        }
        setFilter((prevFilter: any) => ({
            ...prevFilter,
            page: +filterParams.page || prevFilter.page,
            limit: +filterParams.limit || prevFilter.limit,
            year: "",
        }));
        fetchData(data);
        const handleNewToken = () => {
            fetchData(data);
        };
        document.addEventListener("newToken", handleNewToken);
        return () => {
            document.removeEventListener("newToken", handleNewToken);
        };
    }, [path]);
    const formatDate = (dateString: any) => {
        const months = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        const date = new Date(dateString);
        const month = months[date.getMonth()];
        const day = date.getDate();

        return `${month} ${day}`;
    }
    const fetchData = async (data: any) => {
        webLoadingTrue();
        try {
            const response: any = await getDetailAsset(id, companyId, data.page, data.limit, data.year);
            console.log("🚀 ~ fetchData ~ response:", response)
            setFormValues(response.data);
            setEndDate(new Date(response.data.depreciationDate));
            setStartDate(new Date(response.data.purchaseDate));
            setCategoryPurchase(response?.data?.assetCategories?.categoryName);
            let tempArray: any = [];
            response.data.assetDetails.forEach((each: any) => {
                tempArray.push({
                    id: each?.id,
                    No: each?.incrementNo,
                    Date: formatDate(each?.date),
                    "Net Book Value": each?.depricatedValue + " €",
                });
            });
            setTermsArray({ count: response.data.assetDetails?.length, data: tempArray });
        } catch (error) {
            console.error("Error loading terms:", error);
        } finally {
            webLoadingFalse();
        }
    };
    const handleCategorySelect = (categoryId: string, categoryName: string) => {
        setFormValues((prev: any) => ({ ...prev, country: categoryId }));
        setExpandedCategoryId((prev) => (prev === categoryId ? null : categoryId));
    };
    useEffect(() => {
        const fetchCountries = async () => {
            const data = await getCountries();
            setCountries(data);
        };
        fetchCountries();
        const handleNewToken = () => {
            fetchCountries();
        };
        document.addEventListener("newToken", handleNewToken);
        return () => {
            document.removeEventListener("newToken", handleNewToken);
        };
    }, []);
    useEffect(() => {
        getTerms();
        const handleNewToken = () => {
            getTerms();
        };
        document.addEventListener("newToken", handleNewToken);
        return () => {
            document.removeEventListener("newToken", handleNewToken);
        };
    }, []);
    const getYearsFrom2024ToCurrent = () => {
        const currentYear = new Date().getFullYear();
        const years = [];

        for (let year = 2024; year <= currentYear; year++) {
            years.push({
                id: year,
                year: String(year)
            });
        }
        return years;
    }

    const getTerms = async () => {
        try {
            const response = await loadTerm(filter);
            const value: any = response.data;
            setClientsArray(value.data)
        } catch (error) {
            console.error("Error loading terms:", error);
        }
    };
    const handleStartDate = (value: any) => {
        setStartDate(value);
        setFormValues({ ...formValues, startDate: value });
    };
    const handleEndDate = (value: any) => {
        setEndDate(value);
        setFormValues({ ...formValues, dob: value });
    };


    const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
        const { name, value, type } = e.target;
        setFormValues({ ...formValues, [name]: value })
    }


    const handleReceivePageNumber = (pageNumber: number) => {
        setFilter({ ...filter, page: pageNumber })
    }
    const handleSelectYear = (id: string) => {
        const data: any = { ...filter };
        id !== "year" ? data.year = id : data.year = "";
        setFilter(data);
        fetchData(data);
    }
    return (
        <div className="lg:block hidden">
            <div className="py-3 px-4 bg-white rounded-md flex items-center justify-between">
                <div className="flex items-center gap-x-4">
                    <div className="w-6 h-6 flex items-center justify-center cursor-pointer" onClick={() => { webNavigate("/" + preLanguage + '/assets') }}>
                        <LeftIcon />
                    </div>
                    <div>
                        <p className="text-[12px] leading-[20px] font-inter " style={{ color: "#595959" }}>{language && language?.["No & Title"] ? language?.["No & Title"] : "No & Title"}</p>
                        {id !== "new" &&
                            <div className="flex items-center gap-x-2">
                                <p className="text-[16px] leading-[20px] font-inter font-semibold text-[#2A2A2A]">#{no + " - " + formValues?.assetName}</p>
                            </div>
                        }
                    </div>
                </div>
                <div className="flex items-center h-full">
                    <div className="flex itemes-center gap-x-3">
                        <div className="cursor-pointer flex items-center justify-center gap-x-1 rounded-md border border-[#DEDEE2]" style={{ width: "74px", height: "40px", color: '#1E1E36', gap: "6px" }}>
                            <PrintIcon />
                            <p className="text-[14px] leading-[22px] font-inter">{language && language?.["Print"] ? language?.["Print"] : "Print"}</p>
                        </div>
                    </div>
                </div>
            </div >
            <form >
                <div className="rounded-md bg-white flex items-start justify-between" style={{ padding: "20px 14px", marginTop: "12px" }}>
                    <div className="" style={{ width: "32%" }}>
                        <div className="space-y-2">
                            <div className="flex items-center justify-between">
                                <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#121212" }}>{language && language?.["Category"] ? language?.["Category"] : "Category"}</p>
                                <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#6E6E6E" }}>{language && language?.["Required"] ? language?.["Required"] : "Required"}</p>
                            </div>
                            <div className="w-full">
                                <div className="relative" ref={categoryRef}>
                                    <input
                                        disabled
                                        tabIndex={1}
                                        type="text"
                                        value={categoryPurchase}
                                        onChange={(e) => {
                                            setCategoryPurchase(e.target.value);
                                            setIsCategoryDropdownOpen(true);
                                        }}
                                        onClick={() => setIsCategoryDropdownOpen(true)}
                                        readOnly
                                        style={{ pointerEvents: 'all' }}
                                        className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-lg outline-none focus-none bg-transparent w-full`}
                                    />
                                    {isCategoryDropdownOpen && (
                                        <div className="absolute z-[100] w-full mt-1 bg-white border border-[#EBEBED] rounded-lg p-1 shadow-extend" style={{ height: "160px" }}>
                                            <div className="w-full h-full relative">
                                                {listCategory.map((category) => (
                                                    <div key={category.id}>
                                                        <div
                                                            style={{ padding: "8px 6px", borderRadius: "4px" }}
                                                            className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300 flex items-center justify-between"
                                                            onClick={() => handleCategorySelect(category.id, category.name)}
                                                        >
                                                            <p>{category.name}</p>
                                                            <div style={{ rotate: "90deg" }}>
                                                                <ArrowRightIcon />
                                                            </div>
                                                            <div
                                                                style={{
                                                                    width: "100%",
                                                                    position: "absolute",
                                                                    top: 0,
                                                                    left: 0,
                                                                    padding: "4px",
                                                                    zIndex: 300,
                                                                    overflow: "hidden",
                                                                    transition: "transform 0.3s ease-in-out",
                                                                    transform: expandedCategoryId === category.id ? "translateX(0)" : "translateX(120%)",
                                                                    backgroundColor: "white"
                                                                }}
                                                            >
                                                                <div
                                                                    className="flex items-center gap-x-2 cursor-pointer"
                                                                    style={{ padding: "6px 8px", borderBottom: "1px solid #E7F1F1" }}
                                                                    onClick={(e: any) => {
                                                                        e.stopPropagation();
                                                                        setExpandedCategoryId(null);
                                                                    }}
                                                                >
                                                                    <BackIcon />
                                                                    <p className="text-main text-[14px]">{category.name}</p>
                                                                </div>
                                                                {category.children.map((child) => (
                                                                    <div
                                                                        key={child.id}
                                                                        style={{
                                                                            padding: "8px 6px",
                                                                            borderRadius: "4px",
                                                                            cursor: "pointer",
                                                                            transition: "transform 0.3s ease-in-out",
                                                                        }}
                                                                        className="hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                                                                        onClick={() => {
                                                                            setCategoryPurchase(child.name);
                                                                        }}
                                                                    >
                                                                        {child.name}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                        <div style={{ marginTop: "24px" }} className="space-y-2">
                            <div className="flex items-center justify-between">
                                <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#121212" }}>{language && language?.["QTY"] ? language?.["QTY"] : "QTY"}</p>
                            </div>
                            <div className="w-full">
                                <input
                                    disabled
                                    value={formValues?.qty}
                                    tabIndex={4}
                                    onKeyDown={validateNoSpecialChars}
                                    name="qty"
                                    onChange={(e: any) => {
                                        handleChange(e)
                                    }}
                                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                />
                            </div>
                        </div>
                        <div className="space-y-2" style={{ marginTop: "24px" }}>
                            <div className="flex items-center justify-between">
                                <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#121212" }}>{language && language?.["Registration date"] ? language?.["Registration date"] : "Registration date"}</p>
                            </div>
                            <div className="w-full">
                                <DatePicker
                                    tabIndex={6}
                                    showTimeSelect
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText={`Enter a registration date`}
                                    name="startTime"
                                    className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full"
                                    selected={startDate}
                                    onChange={(e) => handleStartDate(e)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="" style={{ width: "32%" }}>
                        <div className="space-y-2">
                            <div className="flex items-center justify-between">
                                <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#121212" }}>{language && language?.["Impairment"] ? language?.["Impairment"] : "Impairment"}</p>
                            </div>
                            <div className="w-full">
                                <input
                                    disabled
                                    value={formValues?.depreciationYears + " years"}
                                    tabIndex={2}
                                    onKeyDown={validateNoSpecialChars}
                                    name="depreciationYears"
                                    onChange={(e: any) => {
                                        handleChange(e)
                                    }}
                                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                />
                            </div>
                        </div>
                        <div style={{ marginTop: "24px" }} className="space-y-2">
                            <div className="flex items-center justify-between">
                                <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#121212" }}>{language && language?.["Price"] ? language?.["Price"] : "Price"}</p>
                            </div>
                            <div className="w-full">
                                <input
                                    disabled
                                    tabIndex={5}
                                    type="text"
                                    name="price"
                                    onKeyDown={validateNoSpecialChars}
                                    value={formValues?.price + " €"}
                                    onChange={(e: any) => {
                                        handleChange(e)
                                    }}
                                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                />
                            </div>
                        </div>
                        <div className="space-y-2" style={{ marginTop: "24px" }}>
                            <div className="flex items-center justify-between">
                                <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#121212" }}>{language && language?.["Impairment date"] ? language?.["Impairment date"] : "Impairment date"}</p>
                            </div>
                            <div className="w-full">
                                <DatePicker
                                    tabIndex={8}
                                    showTimeSelect
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText={`Enter employee’s date of birth`}
                                    name="startTime"
                                    className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full"
                                    selected={endDate}
                                    onChange={(e) => handleEndDate(e)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="" style={{ width: "32%" }}>
                        <div className="space-y-2">
                            <div className="flex items-center justify-between">
                                <p className="text-[14px] font-inter leading-[20px]" style={{ color: "#121212" }}>{language && language?.["Value"] ? language?.["Value"] : "Value"}</p>
                            </div>
                            <div className="w-full">
                                <input
                                    disabled
                                    tabIndex={3}
                                    type="text"
                                    name="amount"
                                    value={formValues?.amount + " €"}
                                    onKeyDown={validateOnlyNumbers}
                                    onChange={(e: any) => {
                                        handleChange(e)
                                    }}
                                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div style={{ height: `calc(100% - 420px)` }} className='lg:block hidden'>
                <TableReport listAsset={getYearsFrom2024ToCurrent()} hiddenAsset={true} PER_PAGE={filter.limit} pageClick={filter.page} languages={language} loading={loading} path="/terms/" data_table={termsArray.data} count={termsArray.count} titleCreate={inforTable} handleSendPageNumber={handleReceivePageNumber} handleYear={handleSelectYear} />
            </div>
        </div>
    )
}
export default CreateAssets